import dynamic from "next/dynamic";

export const DynamicContent024 = dynamic(() => import("./Content024"), {
  suspense: true,
});
